<div id="postToCommunityDialog" class="share-to-community-dialog-container mat-dialog-custom">
  <div class="title-container">
    @if (!communityItem?.id) {
      <h1 class="title" i18n>New Post</h1>
    } @else {
      <h1 class="title" i18n>Edit Post</h1>
    }
    <button
      id="closeDialog"
      class="close button button-link"
      type="button"
      aria-label="close"
      (click)="onCancel()"
      i18n-aria-label
    >
      <svg-icon class="helper-link" src="/assets/icons/close.svg" alt="close" i18n-alt />
    </button>
  </div>
  <div id="itemCard" class="body-container">
    <div class="item">
      <rdx-activity-card
        [communityItem]="communityItem"
        [showViewOnMap]="false"
        [waypointTags]="(waypointTags$ | async) ?? []"
      />
    </div>
    <div class="inputs-container">
      <mat-form-field class="helper-full-width">
        <mat-label i18n>Name</mat-label>
        <input #name="ngModel" id="name" name="name" matInput required [(ngModel)]="communityItem.name" />
        @if (name.invalid && (name.dirty || name.touched)) {
          <mat-error i18n>Name is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="helper-full-width">
        <mat-label i18n>Description</mat-label>
        <textarea
          #description="ngModel"
          id="description"
          name="description"
          rows="3"
          matInput
          [(ngModel)]="communityItem.description"
        ></textarea>
      </mat-form-field>
    </div>
  </div>

  <div class="footer-container">
    <div>
      <span i18n>I certify that this ride complies with the RIDE COMMAND </span>
      <a id="communityPolicyLink" href="javascript:void(0);" (click)="openCommunityPolicy()" i18n>community policy.</a>
    </div>
    <mat-slide-toggle id="certifyToggle" [hideIcon]="true" [(ngModel)]="certify" />
    <button
      id="post"
      class="button primary-button"
      type="button"
      rdcAnalytics="Post To Community"
      [rdcAnalyticsData]="`content type: ${userContentItem.type || communityItem.type}`"
      [disabled]="!certify || isSubmitting"
      (click)="onPost()"
    >
      <span class="title" i18n>Post</span>
    </button>
  </div>
</div>
